export let titlePoints = [
    {x:10.3,y:179.8},
    {x:15.6,y:179.8},
    {x:20.9,y:179.8},
    {x:26.1,y:179.8},
    {x:31.4,y:179.8},
    {x:36.6,y:179.8},
    {x:41.9,y:179.8},
    {x:47.1,y:179.8},
    {x:48.5,y:176.0},
    {x:48.5,y:170.7},
    {x:48.5,y:165.5},
    {x:48.5,y:160.2},
    {x:48.5,y:155.0},
    {x:48.5,y:149.7},
    {x:48.5,y:144.5},
    {x:48.5,y:139.2},
    {x:48.5,y:134.0},
    {x:48.5,y:128.7},
    {x:48.5,y:123.5},
    {x:48.5,y:118.2},
    {x:48.5,y:113.0},
    {x:48.5,y:107.7},
    {x:48.5,y:102.5},
    {x:50.1,y:98.9},
    {x:55.4,y:98.9},
    {x:60.6,y:98.9},
    {x:65.9,y:98.9},
    {x:71.1,y:98.9},
    {x:76.4,y:98.8},
    {x:81.6,y:98.8},
    {x:82.7,y:103.0},
    {x:82.7,y:108.3},
    {x:79.3,y:110.1},
    {x:74.1,y:110.1},
    {x:68.8,y:110.1},
    {x:64.9,y:111.5},
    {x:64.9,y:116.8},
    {x:64.9,y:122.0},
    {x:64.9,y:127.3},
    {x:65.5,y:132},
    {x:70.7,y:132},
    {x:76.0,y:132},
    {x:80.0,y:133.2},
    {x:80.0,y:138.4},
    {x:79.8,y:143.5},
    {x:74.5,y:143.5},
    {x:69.3,y:143.5},
    {x:64.9,y:144.3},
    {x:64.9,y:149.6},
    {x:64.9,y:154.8},
    {x:64.9,y:160.1},
    {x:64.9,y:165.3},
    {x:64.9,y:170.6},
    {x:64.9,y:175.8},
    {x:66.1,y:179.8},
    {x:71.4,y:179.8},
    {x:76.6,y:179.8},
    {x:81.9,y:179.8},
    {x:87.1,y:179.8},
    {x:92.4,y:179.8},
    {x:97.6,y:179.8},
    {x:102.9,y:179.8},
    {x:108.1,y:179.8},
    {x:113.4,y:179.8},
    {x:118.6,y:179.8},
    {x:123.9,y:179.8},
    {x:120.2,y:178.2},
    {x:116.0,y:175.0},
    {x:113.0,y:170.7},
    {x:111.2,y:165.8},
    {x:110.2,y:160.7},
    {x:109.8,y:155.4},
    {x:109.8,y:150.2},
    {x:109.8,y:144.9},
    {x:109.8,y:139.7},
    {x:109.8,y:134.4},
    {x:109.8,y:129.2},
    {x:109.8,y:123.9},
    {x:110.1,y:118.7},
    {x:111.0,y:113.5},
    {x:112.7,y:108.5},
    {x:115.6,y:104.2},
    {x:119.6,y:100.9},
    {x:124.5,y:98.9},
    {x:129.6,y:98.0},
    {x:134.9,y:97.9},
    {x:140.1,y:98.3},
    {x:145.2,y:99.7},
    {x:149.7,y:102.3},
    {x:153.3,y:106.1},
    {x:155.6,y:110.8},
    {x:156.9,y:115.9},
    {x:157.5,y:121.1},
    {x:157.6,y:126.4},
    {x:157.6,y:131.6},
    {x:157.6,y:136.9},
    {x:157.6,y:142.1},
    {x:157.6,y:147.4},
    {x:157.6,y:152.6},
    {x:157.5,y:157.9},
    {x:156.9,y:163.1},
    {x:155.5,y:168.1},
    {x:153.1,y:172.8},
    {x:149.5,y:176.6},
    {x:145.0,y:179.2},
    {x:145.9,y:179.8},
    {x:151.1,y:179.8},
    {x:156.4,y:179.8},
    {x:161.6,y:179.8},
    {x:166.9,y:179.8},
    {x:172.1,y:179.8},
    {x:177.4,y:179.8},
    {x:182.6,y:179.8},
    {x:187.9,y:179.8},
    {x:193.1,y:179.8},
    {x:198.4,y:179.8},
    {x:200.4,y:179.3},
    {x:195.8,y:176.9},
    {x:192.2,y:173.1},
    {x:189.9,y:168.4},
    {x:188.7,y:163.3},
    {x:188.1,y:158.1},
    {x:188.0,y:152.9},
    {x:188.0,y:147.6},
    {x:188.0,y:142.4},
    {x:188.0,y:137.1},
    {x:188.0,y:131.9},
    {x:188.0,y:126.6},
    {x:188.0,y:121.4},
    {x:188.0,y:116.1},
    {x:188.0,y:110.9},
    {x:188.0,y:105.6},
    {x:188.0,y:100.3},
    {x:191.8,y:98.9},
    {x:197.0,y:98.9},
    {x:202.3,y:98.9},
    {x:204.2,y:102.2},
    {x:204.2,y:107.4},
    {x:204.2,y:112.7},
    {x:204.2,y:117.9},
    {x:204.2,y:123.2},
    {x:204.2,y:128.4},
    {x:204.2,y:133.7},
    {x:204.2,y:138.9},
    {x:204.2,y:144.2},
    {x:204.2,y:149.4},
    {x:204.2,y:154.7},
    {x:204.3,y:159.9},
    {x:205.4,y:165.1},
    {x:208.9,y:168.6},
    {x:214.1,y:168.5},
    {x:217.5,y:164.8},
    {x:218.5,y:159.7},
    {x:218.6,y:154.4},
    {x:218.6,y:149.2},
    {x:218.6,y:143.9},
    {x:218.6,y:138.7},
    {x:218.6,y:133.4},
    {x:218.6,y:128.2},
    {x:218.6,y:122.9},
    {x:218.6,y:117.7},
    {x:218.6,y:112.4},
    {x:218.6,y:107.2},
    {x:218.6,y:101.9},
    {x:220.8,y:98.9},
    {x:226.0,y:98.9},
    {x:231.3,y:98.9},
    {x:234.9,y:100.5},
    {x:234.9,y:105.7},
    {x:234.9,y:111.0},
    {x:234.9,y:116.2},
    {x:234.9,y:121.5},
    {x:234.9,y:126.7},
    {x:234.9,y:132.0},
    {x:234.9,y:137.2},
    {x:234.9,y:142.5},
    {x:234.9,y:147.7},
    {x:234.9,y:153.0},
    {x:234.8,y:158.2},
    {x:234.2,y:163.5},
    {x:233.0,y:168.6},
    {x:230.6,y:173.2},
    {x:227.0,y:177.0},
    {x:222.3,y:179.4},
    {x:224.6,y:179.8},
    {x:229.8,y:179.8},
    {x:235.1,y:179.8},
    {x:240.3,y:179.8},
    {x:245.6,y:179.8},
    {x:250.8,y:179.8},
    {x:256.1,y:179.8},
    {x:261.3,y:179.8},
    {x:266.6,y:179.8},
    {x:271.8,y:179.8},
    {x:277.1,y:179.8},
    {x:282.3,y:179.8},
    {x:287.6,y:179.8},
    {x:292.8,y:179.8},
    {x:298.0,y:179.8},
    {x:296.7,y:174.7},
    {x:295.4,y:169.6},
    {x:294.2,y:164.5},
    {x:292.9,y:159.4},
    {x:291.6,y:154.3},
    {x:290.3,y:149.2},
    {x:289.0,y:144.1},
    {x:284.5,y:143.1},
    {x:282.8,y:146.7},
    {x:282.8,y:151.9},
    {x:282.8,y:157.2},
    {x:282.8,y:162.4},
    {x:282.8,y:167.7},
    {x:282.8,y:172.9},
    {x:282.8,y:178.2},
    {x:277.8,y:178.5},
    {x:272.6,y:178.5},
    {x:267.3,y:178.5},
    {x:266.4,y:174.1},
    {x:266.4,y:168.9},
    {x:266.4,y:163.6},
    {x:266.4,y:158.4},
    {x:266.4,y:153.1},
    {x:266.4,y:147.9},
    {x:266.4,y:142.6},
    {x:266.4,y:137.4},
    {x:266.4,y:132.1},
    {x:266.4,y:126.9},
    {x:266.4,y:121.6},
    {x:266.4,y:116.4},
    {x:266.4,y:111.1},
    {x:266.4,y:105.9},
    {x:266.4,y:100.6},
    {x:269.9,y:98.9},
    {x:275.1,y:98.9},
    {x:280.4,y:98.9},
    {x:285.6,y:98.9},
    {x:290.9,y:98.9},
    {x:296.1,y:99.5},
    {x:301.2,y:100.7},
    {x:306.0,y:102.9},
    {x:309.9,y:106.4},
    {x:312.3,y:111.0},
    {x:313.5,y:116.1},
    {x:313.7,y:121.3},
    {x:313.3,y:126.6},
    {x:312.0,y:131.7},
    {x:309.5,y:136.2},
    {x:305.4,y:139.5},
    {x:304.6,y:143.6},
    {x:306.0,y:148.6},
    {x:307.5,y:153.7},
    {x:308.9,y:158.7},
    {x:310.3,y:163.8},
    {x:311.8,y:168.8},
    {x:313.2,y:173.9},
    {x:314.6,y:178.9},
    {x:319.2,y:179.8},
    {x:324.5,y:179.8},
    {x:329.7,y:179.8},
    {x:335.0,y:179.8},
    {x:340.2,y:179.8},
    {x:344.9,y:179.3},
    {x:344.9,y:174.0},
    {x:344.9,y:168.8},
    {x:344.9,y:163.5},
    {x:344.9,y:158.3},
    {x:344.9,y:153.0},
    {x:344.9,y:147.8},
    {x:344.9,y:142.5},
    {x:344.9,y:137.3},
    {x:344.9,y:132.0},
    {x:344.9,y:126.8},
    {x:344.9,y:121.5},
    {x:344.9,y:116.3},
    {x:344.9,y:111.0},
    {x:344.9,y:105.8},
    {x:344.9,y:100.5},
    {x:348.5,y:98.9},
    {x:353.7,y:98.9},
    {x:359.0,y:98.9},
    {x:361.3,y:101.8},
    {x:361.3,y:107.0},
    {x:361.3,y:112.3},
    {x:361.3,y:117.5},
    {x:361.3,y:122.8},
    {x:361.3,y:128.0},
    {x:361.3,y:133.3},
    {x:361.3,y:138.6},
    {x:361.3,y:143.8},
    {x:361.3,y:149.1},
    {x:361.3,y:154.3},
    {x:361.3,y:159.6},
    {x:361.3,y:164.8},
    {x:361.3,y:170.1},
    {x:361.3,y:175.3},
    {x:362.0,y:179.8},
    {x:367.3,y:179.8},
    {x:372.5,y:179.8},
    {x:377.8,y:179.8},
    {x:383.0,y:179.8},
    {x:388.3,y:179.8},
    {x:393.5,y:179.8},
    {x:393.6,y:174.7},
    {x:393.6,y:169.4},
    {x:393.6,y:164.2},
    {x:393.6,y:158.9},
    {x:393.6,y:153.7},
    {x:393.6,y:148.4},
    {x:393.6,y:143.2},
    {x:393.6,y:137.9},
    {x:393.6,y:132.7},
    {x:393.6,y:127.4},
    {x:393.6,y:122.2},
    {x:393.6,y:116.9},
    {x:393.6,y:111.7},
    {x:393.6,y:106.4},
    {x:393.6,y:101.2},
    {x:396.5,y:98.9},
    {x:401.8,y:98.9},
    {x:407.1,y:98.9},
    {x:412.3,y:98.9},
    {x:417.6,y:98.9},
    {x:422.8,y:98.8},
    {x:428.1,y:98.8},
    {x:428.9,y:103.3},
    {x:428.9,y:108.5},
    {x:425.4,y:110.3},
    {x:420.1,y:110.3},
    {x:414.9,y:110.3},
    {x:410.0,y:110.6},
    {x:410.0,y:115.9},
    {x:410.0,y:121.1},
    {x:410.0,y:126.4},
    {x:410.0,y:131.6},
    {x:415.1,y:131.8},
    {x:420.4,y:131.8},
    {x:424.6,y:132.8},
    {x:424.6,y:138.0},
    {x:424.6,y:143.3},
    {x:419.3,y:143.3},
    {x:414.1,y:143.3},
    {x:410.0,y:144.4},
    {x:410.0,y:149.7},
    {x:410.0,y:154.9},
    {x:410.0,y:160.2},
    {x:410.0,y:165.4},
    {x:412.0,y:168.6},
    {x:417.3,y:168.6},
    {x:422.5,y:168.6},
    {x:427.8,y:168.6},
    {x:429.1,y:172.6},
    {x:429.1,y:177.9},
    {x:432.4,y:179.8},
    {x:437.6,y:179.8},
    {x:442.9,y:179.8},
    {x:448.1,y:179.8},
    {x:453.4,y:179.8},
    {x:458.6,y:179.8},
    {x:463.9,y:179.8},
    {x:469.1,y:179.8},
    {x:474.4,y:179.8},
    {x:479.6,y:179.8},
    {x:484.9,y:179.8},
    {x:488.9,y:178.9},
    {x:487.6,y:173.8},
    {x:486.3,y:168.7},
    {x:485.0,y:163.6},
    {x:483.7,y:158.5},
    {x:482.5,y:153.4},
    {x:481.2,y:148.3},
    {x:479.9,y:143.2},
    {x:474.7,y:143.1},
    {x:473.9,y:147.6},
    {x:473.9,y:152.9},
    {x:473.9,y:158.1},
    {x:473.9,y:163.4},
    {x:473.9,y:168.6},
    {x:473.9,y:173.9},
    {x:473.2,y:178.5},
    {x:468.0,y:178.5},
    {x:462.7,y:178.5},
    {x:457.5,y:178.4},
    {x:457.5,y:173.2},
    {x:457.5,y:167.9},
    {x:457.5,y:162.7},
    {x:457.5,y:157.4},
    {x:457.5,y:152.2},
    {x:457.5,y:146.9},
    {x:457.5,y:141.7},
    {x:457.5,y:136.4},
    {x:457.5,y:131.2},
    {x:457.5,y:125.9},
    {x:457.5,y:120.7},
    {x:457.5,y:115.4},
    {x:457.5,y:110.2},
    {x:457.5,y:104.9},
    {x:457.5,y:99.7},
    {x:461.9,y:98.9},
    {x:467.2,y:98.9},
    {x:472.4,y:98.9},
    {x:477.7,y:98.9},
    {x:482.9,y:99.0},
    {x:488.1,y:99.7},
    {x:493.2,y:101.0},
    {x:497.9,y:103.4},
    {x:501.5,y:107.1},
    {x:503.7,y:111.9},
    {x:504.7,y:117.0},
    {x:504.8,y:122.3},
    {x:504.2,y:127.5},
    {x:502.8,y:132.5},
    {x:499.9,y:136.9},
    {x:495.7,y:139.9},
    {x:496.0,y:144.5},
    {x:497.4,y:149.5},
    {x:498.8,y:154.6},
    {x:500.3,y:159.6},
    {x:501.7,y:164.7},
    {x:503.1,y:169.7},
    {x:504.6,y:174.8},
    {x:506.0,y:179.8},
    {x:511.3,y:179.8},
    {x:516.5,y:179.8},
    {x:521.8,y:179.8},
    {x:527.0,y:179.8},
    {x:532.3,y:179.8},
    {x:537.5,y:179.8},
    {x:542.8,y:179.8},
    {x:543.7,y:184.2},
    {x:543.7,y:189.5},
    {x:543.7,y:194.7},
    {x:543.7,y:200.0},
    {x:543.7,y:205.2},
    {x:543.7,y:210.5},
    {x:543.7,y:215.7},
    {x:541.7,y:219.1},
    {x:536.5,y:219.1},
    {x:531.2,y:219.1},
    {x:535.8,y:221.3},
    {x:539.3,y:225.2},
    {x:541.6,y:229.9},
    {x:543.0,y:235.0},
    {x:543.6,y:240.2},
    {x:538.8,y:241.3},
    {x:533.6,y:242.0},
    {x:529.3,y:241.7},
    {x:528.8,y:236.5},
    {x:526.9,y:231.7},
    {x:522.1,y:230.2},
    {x:518.1,y:233.2},
    {x:517.3,y:238.4},
    {x:518.7,y:243.4},
    {x:522.0,y:247.5},
    {x:525.9,y:251.0},
    {x:529.8,y:254.5},
    {x:533.8,y:258.0},
    {x:537.4,y:261.7},
    {x:540.6,y:265.9},
    {x:543.2,y:270.5},
    {x:544.7,y:275.5},
    {x:545.1,y:280.7},
    {x:544.6,y:285.9},
    {x:542.9,y:290.8},
    {x:539.8,y:295.1},
    {x:535.7,y:298.3},
    {x:530.8,y:300.3},
    {x:525.6,y:301.1},
    {x:520.4,y:301.0},
    {x:515.3,y:299.9},
    {x:510.5,y:297.7},
    {x:506.7,y:294.1},
    {x:504.0,y:289.6},
    {x:502.4,y:284.6},
    {x:501.6,y:279.4},
    {x:503.1,y:275.7},
    {x:508.3,y:274.8},
    {x:513.5,y:273.9},
    {x:515.7,y:276.7},
    {x:516.5,y:281.8},
    {x:518.8,y:286.5},
    {x:523.5,y:288.5},
    {x:528.0,y:286.4},
    {x:529.0,y:281.3},
    {x:528.1,y:276.2},
    {x:525.4,y:271.7},
    {x:521.7,y:267.9},
    {x:517.8,y:264.4},
    {x:513.8,y:261.0},
    {x:509.9,y:257.5},
    {x:506.4,y:253.6},
    {x:503.6,y:249.2},
    {x:502.0,y:244.2},
    {x:501.5,y:239.0},
    {x:501.9,y:233.7},
    {x:503.4,y:228.7},
    {x:506.3,y:224.4},
    {x:510.4,y:221.1},
    {x:515.2,y:219.1},
    {x:510.3,y:219.1},
    {x:505.1,y:219.1},
    {x:499.8,y:219.1},
    {x:494.6,y:219.1},
    {x:490.0,y:219.7},
    {x:490.1,y:224.9},
    {x:490.2,y:230.2},
    {x:490.3,y:235.4},
    {x:490.4,y:240.7},
    {x:490.4,y:245.9},
    {x:490.5,y:251.2},
    {x:490.6,y:256.4},
    {x:490.7,y:261.7},
    {x:490.8,y:266.9},
    {x:490.9,y:272.2},
    {x:491.0,y:277.4},
    {x:491.1,y:282.7},
    {x:491.2,y:287.9},
    {x:491.3,y:293.2},
    {x:491.4,y:298.4},
    {x:487.8,y:300.1},
    {x:482.6,y:300.1},
    {x:479.4,y:297.9},
    {x:479.3,y:292.7},
    {x:479.2,y:287.4},
    {x:479.0,y:282.2},
    {x:478.9,y:276.9},
    {x:478.8,y:271.7},
    {x:478.7,y:266.4},
    {x:478.5,y:261.2},
    {x:478.4,y:255.9},
    {x:478.3,y:250.7},
    {x:478.2,y:245.4},
    {x:477.2,y:249.9},
    {x:476.3,y:255.0},
    {x:475.3,y:260.2},
    {x:474.3,y:265.3},
    {x:473.3,y:270.5},
    {x:472.4,y:275.7},
    {x:471.4,y:280.8},
    {x:470.4,y:286.0},
    {x:469.4,y:291.1},
    {x:468.5,y:296.3},
    {x:466.3,y:300.1},
    {x:461.1,y:300.1},
    {x:457.2,y:298.3},
    {x:456.2,y:293.2},
    {x:455.2,y:288.0},
    {x:454.2,y:282.9},
    {x:453.2,y:277.7},
    {x:452.2,y:272.6},
    {x:451.2,y:267.4},
    {x:450.2,y:262.3},
    {x:449.2,y:257.1},
    {x:448.2,y:251.9},
    {x:447.2,y:246.8},
    {x:446.8,y:247.9},
    {x:446.7,y:253.2},
    {x:446.6,y:258.4},
    {x:446.4,y:263.7},
    {x:446.3,y:268.9},
    {x:446.2,y:274.2},
    {x:446.1,y:279.4},
    {x:446.0,y:284.7},
    {x:445.9,y:289.9},
    {x:445.8,y:295.2},
    {x:445.3,y:300.1},
    {x:440.0,y:300.1},
    {x:434.8,y:300.1},
    {x:433.6,y:296.0},
    {x:433.7,y:290.8},
    {x:433.8,y:285.5},
    {x:433.9,y:280.3},
    {x:434.0,y:275.0},
    {x:434.1,y:269.8},
    {x:434.2,y:264.5},
    {x:434.3,y:259.3},
    {x:434.3,y:254.0},
    {x:434.4,y:248.8},
    {x:434.5,y:243.5},
    {x:434.6,y:238.3},
    {x:434.7,y:233.0},
    {x:434.8,y:227.8},
    {x:434.9,y:222.5},
    {x:433.2,y:219.1},
    {x:427.9,y:219.1},
    {x:422.6,y:219.1},
    {x:417.4,y:219.1},
    {x:412.1,y:219.1},
    {x:406.9,y:219.1},
    {x:401.6,y:219.1},
    {x:399.9,y:219.1},
    {x:405.1,y:219.7},
    {x:410.2,y:220.9},
    {x:415.0,y:223.0},
    {x:419.0,y:226.5},
    {x:421.4,y:231.0},
    {x:422.6,y:236.2},
    {x:422.8,y:241.4},
    {x:422.4,y:246.6},
    {x:421.2,y:251.7},
    {x:418.7,y:256.3},
    {x:414.7,y:259.6},
    {x:413.7,y:263.6},
    {x:415.2,y:268.7},
    {x:416.6,y:273.7},
    {x:418.0,y:278.8},
    {x:419.5,y:283.8},
    {x:420.9,y:288.9},
    {x:422.3,y:294.0},
    {x:423.8,y:299.0},
    {x:419.9,y:300.1},
    {x:414.6,y:300.1},
    {x:409.4,y:300.1},
    {x:406.4,y:297.1},
    {x:405.1,y:292.0},
    {x:403.9,y:286.9},
    {x:402.6,y:281.8},
    {x:401.3,y:276.7},
    {x:400.0,y:271.7},
    {x:398.8,y:266.6},
    {x:396.0,y:263.3},
    {x:392,y:264.5},
    {x:392,y:269.8},
    {x:392,y:275.0},
    {x:392,y:280.3},
    {x:392,y:285.6},
    {x:392,y:290.8},
    {x:392,y:296.1},
    {x:390.7,y:300.1},
    {x:385.4,y:300.1},
    {x:380.2,y:300.1},
    {x:375.6,y:299.4},
    {x:375.6,y:294.2},
    {x:375.6,y:288.9},
    {x:375.6,y:283.7},
    {x:375.6,y:278.4},
    {x:375.6,y:273.2},
    {x:375.6,y:267.9},
    {x:375.6,y:262.7},
    {x:375.6,y:257.4},
    {x:375.6,y:252.2},
    {x:375.6,y:246.9},
    {x:375.6,y:241.7},
    {x:375.6,y:236.4},
    {x:375.6,y:231.2},
    {x:375.6,y:225.9},
    {x:375.6,y:220.7},
    {x:371.9,y:219.1},
    {x:366.7,y:219.1},
    {x:361.4,y:219.1},
    {x:356.2,y:219.1},
    {x:350.9,y:219.1},
    {x:353.1,y:220.3},
    {x:357.5,y:223.1},
    {x:360.8,y:227.2},
    {x:362.9,y:232.0},
    {x:364.1,y:237.1},
    {x:364.5,y:242.4},
    {x:364.6,y:247.6},
    {x:364.6,y:252.9},
    {x:364.6,y:258.1},
    {x:364.6,y:263.4},
    {x:364.6,y:268.6},
    {x:364.6,y:273.9},
    {x:364.4,y:279.1},
    {x:363.6,y:284.3},
    {x:362.0,y:289.3},
    {x:359.4,y:293.9},
    {x:355.6,y:297.5},
    {x:350.9,y:299.7},
    {x:345.8,y:300.8},
    {x:340.5,y:301.1},
    {x:335.3,y:300.8},
    {x:330.2,y:299.7},
    {x:325.5,y:297.4},
    {x:321.7,y:293.7},
    {x:319.2,y:289.2},
    {x:317.7,y:284.1},
    {x:316.9,y:278.9},
    {x:316.7,y:273.7},
    {x:316.7,y:268.4},
    {x:316.7,y:263.2},
    {x:316.7,y:257.9},
    {x:316.7,y:252.7},
    {x:316.7,y:247.4},
    {x:316.8,y:242.2},
    {x:317.3,y:237.0},
    {x:318.4,y:231.8},
    {x:320.6,y:227.1},
    {x:323.9,y:223.0},
    {x:328.3,y:220.2},
    {x:330.2,y:219.1},
    {x:324.9,y:219.1},
    {x:319.7,y:219.1},
    {x:314.4,y:219.1},
    {x:309.7,y:219.5},
    {x:309.7,y:224.8},
    {x:309.7,y:230.1},
    {x:304.7,y:230.3},
    {x:299.4,y:230.3},
    {x:294.2,y:230.3},
    {x:291.8,y:233.3},
    {x:291.8,y:238.5},
    {x:291.8,y:243.8},
    {x:291.8,y:249.0},
    {x:294.0,y:252.1},
    {x:299.2,y:252.1},
    {x:304.5,y:252.1},
    {x:307,y:254.9},
    {x:307,y:260.2},
    {x:305.2,y:263.7},
    {x:299.9,y:263.7},
    {x:294.7,y:263.7},
    {x:291.8,y:266.1},
    {x:291.8,y:271.3},
    {x:291.8,y:276.6},
    {x:291.8,y:281.8},
    {x:291.8,y:287.1},
    {x:291.8,y:292.3},
    {x:291.8,y:297.6},
    {x:289.1,y:300.1},
    {x:283.8,y:300.1},
    {x:278.6,y:300.1},
    {x:275.5,y:297.9},
    {x:275.5,y:292.7},
    {x:275.5,y:287.4},
    {x:275.5,y:282.2},
    {x:275.5,y:276.9},
    {x:275.5,y:271.6},
    {x:275.5,y:266.4},
    {x:275.5,y:261.1},
    {x:275.5,y:255.9},
    {x:275.5,y:250.6},
    {x:275.5,y:245.4},
    {x:275.5,y:240.1},
    {x:275.5,y:234.9},
    {x:275.5,y:229.6},
    {x:275.5,y:224.4},
    {x:275.5,y:219.1},
    {x:270.3,y:219.1},
    {x:265.0,y:219.1},
    {x:259.8,y:219.1},
    {x:254.5,y:219.1},
    {x:256.0,y:220.4},
    {x:259.9,y:223.8},
    {x:262.5,y:228.3},
    {x:264.2,y:233.3},
    {x:265.1,y:238.5},
    {x:262.1,y:241.0},
    {x:256.9,y:241.8},
    {x:251.7,y:242.5},
    {x:250.6,y:238.2},
    {x:249.5,y:233.1},
    {x:245.4,y:230.2},
    {x:240.6,y:231.8},
    {x:238.9,y:236.7},
    {x:239.6,y:241.8},
    {x:242.4,y:246.2},
    {x:246.2,y:249.9},
    {x:250.1,y:253.4},
    {x:254.1,y:256.8},
    {x:257.9,y:260.4},
    {x:261.2,y:264.5},
    {x:264.1,y:268.9},
    {x:265.9,y:273.8},
    {x:266.7,y:279.0},
    {x:266.5,y:284.2},
    {x:265.2,y:289.3},
    {x:262.5,y:293.8},
    {x:258.7,y:297.4},
    {x:254.1,y:299.8},
    {x:249.0,y:301.0},
    {x:243.7,y:301.1},
    {x:238.5,y:300.4},
    {x:233.6,y:298.5},
    {x:229.4,y:295.4},
    {x:226.4,y:291.1},
    {x:224.5,y:286.3},
    {x:223.4,y:281.1},
    {x:223.0,y:275.9},
    {x:228.2,y:275.1},
    {x:233.4,y:274.2},
    {x:237.2,y:275.0},
    {x:237.8,y:280.2},
    {x:239.4,y:285.1},
    {x:243.4,y:288.3},
    {x:248.4,y:287.6},
    {x:250.6,y:283.0},
    {x:250.2,y:277.8},
    {x:248.0,y:273.0},
    {x:244.6,y:269.1},
    {x:240.7,y:265.5},
    {x:236.7,y:262.1},
    {x:232.8,y:258.6},
    {x:229.1,y:254.9},
    {x:226.0,y:250.7},
    {x:224.0,y:245.9},
    {x:223.1,y:240.7},
    {x:223.2,y:235.4},
    {x:224.4,y:230.3},
    {x:226.8,y:225.7},
    {x:230.6,y:222.1},
    {x:235.2,y:219.6},
    {x:233.5,y:219.1},
    {x:228.3,y:219.1},
    {x:223.0,y:219.1},
    {x:217.8,y:219.1},
    {x:212.8,y:219.3},
    {x:212.8,y:224.5},
    {x:212.8,y:229.8},
    {x:212.8,y:235.0},
    {x:212.8,y:240.3},
    {x:212.8,y:245.5},
    {x:212.8,y:250.8},
    {x:212.8,y:256.0},
    {x:212.8,y:261.3},
    {x:212.8,y:266.5},
    {x:212.8,y:271.8},
    {x:212.8,y:277.0},
    {x:212.8,y:282.3},
    {x:212.8,y:287.5},
    {x:212.8,y:292.8},
    {x:212.8,y:298.0},
    {x:209.5,y:300.1},
    {x:204.3,y:300.1},
    {x:200.7,y:297.6},
    {x:198.7,y:292.7},
    {x:196.7,y:287.9},
    {x:194.8,y:283.0},
    {x:192.8,y:278.1},
    {x:190.9,y:273.2},
    {x:188.9,y:268.4},
    {x:187.0,y:263.5},
    {x:185.0,y:258.6},
    {x:183.6,y:256.9},
    {x:183.6,y:262.1},
    {x:183.6,y:267.4},
    {x:183.6,y:272.6},
    {x:183.6,y:277.9},
    {x:183.6,y:283.1},
    {x:183.6,y:288.4},
    {x:183.6,y:293.6},
    {x:183.6,y:298.9},
    {x:179.6,y:300.1},
    {x:174.3,y:300.1},
    {x:169.6,y:299.6},
    {x:169.6,y:294.3},
    {x:169.6,y:289.1},
    {x:169.6,y:283.8},
    {x:169.6,y:278.6},
    {x:169.6,y:273.3},
    {x:169.6,y:268.0},
    {x:169.6,y:262.8},
    {x:169.6,y:257.5},
    {x:169.6,y:252.3},
    {x:169.6,y:247.0},
    {x:169.6,y:241.8},
    {x:169.6,y:236.5},
    {x:169.6,y:231.3},
    {x:169.6,y:226.0},
    {x:169.6,y:220.8},
    {x:166.0,y:219.1},
    {x:160.8,y:219.1},
    {x:155.5,y:219.1},
    {x:150.3,y:219.1},
    {x:145.9,y:219.8},
    {x:146.9,y:224.9},
    {x:147.9,y:230.1},
    {x:148.9,y:235.2},
    {x:149.9,y:240.4},
    {x:150.9,y:245.5},
    {x:151.8,y:250.7},
    {x:152.8,y:255.9},
    {x:153.8,y:261.0},
    {x:154.8,y:266.2},
    {x:155.8,y:271.3},
    {x:156.8,y:276.5},
    {x:157.8,y:281.6},
    {x:158.8,y:286.8},
    {x:159.8,y:292.0},
    {x:160.8,y:297.1},
    {x:159.1,y:300.1},
    {x:153.8,y:300.1},
    {x:148.6,y:300.1},
    {x:145.7,y:297.3},
    {x:144.8,y:292.1},
    {x:143.9,y:286.9},
    {x:142.6,y:282.2},
    {x:137.4,y:282.2},
    {x:132.1,y:282.2},
    {x:129.8,y:285.7},
    {x:128.9,y:290.8},
    {x:128.0,y:296.0},
    {x:126.1,y:300.1},
    {x:120.8,y:300.1},
    {x:115.6,y:300.1},
    {x:112.0,y:298.7},
    {x:113.0,y:293.5},
    {x:114.0,y:288.3},
    {x:115.0,y:283.2},
    {x:116.0,y:278.0},
    {x:117.0,y:272.9},
    {x:118.0,y:267.7},
    {x:119.0,y:262.6},
    {x:120.0,y:257.4},
    {x:121.0,y:252.3},
    {x:122.0,y:247.1},
    {x:123.0,y:241.9},
    {x:124.0,y:236.8},
    {x:125.0,y:231.6},
    {x:126.0,y:226.5},
    {x:127.0,y:221.3},
    {x:124.5,y:219.1},
    {x:119.3,y:219.1},
    {x:114.0,y:219.1},
    {x:108.8,y:219.1},
    {x:103.5,y:219.1},
    {x:98.3,y:219.1},
    {x:93.0,y:219.1},
    {x:87.8,y:219.1},
    {x:82.5,y:219.1},
    {x:82.8,y:219.2},
    {x:88.1,y:219.8},
    {x:93.1,y:221.2},
    {x:97.8,y:223.6},
    {x:101.5,y:227.3},
    {x:103.7,y:232.0},
    {x:104.6,y:237.2},
    {x:104.7,y:242.4},
    {x:104.2,y:247.7},
    {x:102.8,y:252.7},
    {x:99.9,y:257.1},
    {x:95.7,y:260.1},
    {x:95.9,y:264.6},
    {x:97.3,y:269.7},
    {x:98.8,y:274.7},
    {x:100.2,y:279.8},
    {x:101.6,y:284.8},
    {x:103.1,y:289.9},
    {x:104.5,y:294.9},
    {x:105.9,y:300.0},
    {x:100.7,y:300.1},
    {x:95.5,y:300.1},
    {x:90.2,y:300.1},
    {x:88.1,y:296.1},
    {x:86.8,y:291.0},
    {x:85.5,y:285.9},
    {x:84.2,y:280.8},
    {x:83.0,y:275.7},
    {x:81.7,y:270.6},
    {x:80.4,y:265.6},
    {x:76.9,y:263.3},
    {x:73.9,y:265.6},
    {x:73.9,y:270.8},
    {x:73.9,y:276.1},
    {x:73.9,y:281.3},
    {x:73.9,y:286.6},
    {x:73.9,y:291.8},
    {x:73.9,y:297.1},
    {x:71.6,y:300.1},
    {x:66.3,y:300.1},
    {x:61.1,y:300.1},
    {x:57.5,y:298.4},
    {x:57.5,y:293.1},
    {x:57.5,y:287.9},
    {x:57.5,y:282.6},
    {x:57.5,y:277.4},
    {x:57.5,y:272.1},
    {x:57.5,y:266.9},
    {x:57.5,y:261.6},
    {x:57.5,y:256.4},
    {x:57.5,y:251.1},
    {x:57.5,y:245.9},
    {x:57.5,y:240.6},
    {x:57.5,y:235.4},
    {x:57.5,y:230.1},
    {x:57.5,y:224.9},
    {x:57.5,y:219.6},
    {x:52.8,y:219.1},
    {x:50.2,y:221.7},
    {x:50.2,y:226.9},
    {x:49.2,y:231.3},
    {x:44.0,y:231.3},
    {x:38.7,y:231.3},
    {x:37.9,y:235.6},
    {x:37.9,y:240.9},
    {x:37.9,y:246.1},
    {x:37.9,y:251.4},
    {x:37.9,y:256.6},
    {x:37.9,y:261.9},
    {x:37.9,y:267.1},
    {x:37.9,y:272.4},
    {x:37.9,y:277.6},
    {x:37.9,y:282.9},
    {x:37.9,y:288.1},
    {x:37.9,y:293.4},
    {x:37.9,y:298.7},
    {x:34.0,y:300.1},
    {x:28.7,y:300.1},
    {x:23.5,y:300.1},
    {x:21.2,y:297.0},
    {x:21.2,y:291.8},
    {x:21.2,y:286.5},
    {x:21.2,y:281.3},
    {x:21.3,y:276.0},
    {x:21.3,y:270.8},
    {x:21.3,y:265.5},
    {x:21.3,y:260.3},
    {x:21.3,y:255.0},
    {x:21.3,y:249.8},
    {x:21.3,y:244.5},
    {x:21.3,y:239.3},
    {x:21.3,y:234.0},
    {x:18.8,y:231.3},
    {x:13.5,y:231.3},
    {x:8.8,y:230.8},
    {x:8.8,y:225.5},
    {x:8.8,y:220.3},
    {x:8.8,y:215.0},
    {x:8.8,y:209.8},
    {x:8.8,y:204.5},
    {x:8.8,y:199.3},
    {x:8.8,y:194.0},
    {x:8.8,y:188.8},
    {x:8.8,y:183.5},
]